import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import i18n from './locales'
import {setupI18n} from "@/locales/setup"
import App from './App.vue'
import pinia from './store'
import router from './router'
import pi from './pi'

async function bootstrap() {
	await setupI18n();
	const app = createApp(App);

	app.use(pinia);
	app.use(router);
	app.use(ElementPlus);
	app.use(i18n);
	app.use(pi);

	//挂载app
	app.mount('#app');
}

bootstrap()



